/*
 * @Description: 
 */
/*
 * @Description:
 */
/*
 * @Description:
 */

import CryptoJs from "crypto-js"; //引入

const key = CryptoJs.enc.Utf8.parse("1234123412ABCDEF"); //设置十六位十六进制数作为密钥
const step = CryptoJs.enc.Utf8.parse("ABCDEF1234123412"); //设置十六位十六进制数作为密 钥偏移量
const Tools = {
	encode(str) {
		return window.btoa(
			encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
				return String.fromCharCode("0x" + p1);
			})
		);
	},
	getCosPath() {
		// 获取服务器时间
		let date = new Date();
		let sdate = date.getFullYear() + "" + (date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1));
		// 生成UUID
		let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
			var r = (Math.random() * 16) | 0,
				v = c == "x" ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
		return sdate + "/" + uuid;
		// console.log(this.cosPath)
	},

	//解密方法
	DeCrypt(text) {
		let enCrytedStr = CryptoJs.enc.Hex.parse(text);
		let srcs = CryptoJs.enc.Base64.stringify(enCrytedStr);
		let deCrypt = CryptoJs.AES.decrypt(srcs, key, { iv: step, mode: CryptoJs.mode.CBC, padding: CryptoJs.pad.Pkcs7 });
		let deCryptedStr = deCrypt.toString(CryptoJs.enc.Utf8);
		return deCryptedStr.toString();
	},

	//加密方法
	EnCrypt(text) {
		let srcs = CryptoJs.enc.Utf8.parse(text);
		let encrypted = CryptoJs.AES.encrypt(srcs, key, { iv: step, mode: CryptoJs.mode.CBC, padding: CryptoJs.pad.Pkcs7 });
		return encrypted.ciphertext.toString().toUpperCase();
	},

    
	debounce(func, delay=2000) {
		let timer; // 定义计时器变量
        console.log('func',func)
		return () => {
			clearTimeout(timer); // 清除上一次的计时器

			const context = this; // 保存this指向
			const args = arguments; // 保存参数列表

			timer = setTimeout(() => {
				func.apply(context, args); // 使用setTimeout延迟执行传入的函数
			}, delay);
		};
	},
};

/**
 * 使用方法
 * this.Tools.getUrlParamsString
 *
 */
export default Tools;
